import React, { useContext, useState } from 'react'
import Price from 'app/React/Components/Footer/Price'
import clx from 'classnames'
import { getCurrentPrice } from "app/React/Helpers/PriceHelper";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function RemoveOption({ option, price, classname, format, onChange = null }) {
  const {
    cartItems,
    currentVariant,
    order,
    strings,
    setCartItems,
    setOrder,
  } = useContext(ConfiguratorContext)

  const [isShown, setIsShown] = useState(false)

  const canBeRemoved = option.can_be_removed ?? false

  const removeOption = () => {
    if (option.type !== 'accessory-product') {
      return
    }

    const newCartItems = cartItems.filter((item) => item.id !== option.accessory_product_obj.id)
    setCartItems(newCartItems)

    order.price = getCurrentPrice(order.paymentType, order, currentVariant, newCartItems)
    setOrder({ ...order })
  }

  return (
    <div
      className={clx('', { 'can-be-removed': canBeRemoved })}
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
      onClick={canBeRemoved ? removeOption : null}
    >
      <div className='config-overview__price-price'>
        {price !== null ? (
          <Price price={price} format={format} classname={clx('price', { hidden: isShown })}/>
        ) : (
          <div className='price'>&nbsp;</div>
        )}
        {canBeRemoved ? <span className={clx('remove', { shown: isShown })}>fjern</span> : null}
      </div>

      {canBeRemoved ? (
        <div className='config-overview__price-remove'>
          <img src={strings.icons.close_dark} alt='close'/>
        </div>
      ) : null}
    </div>
  )
}

RemoveOption.defaultProps = {
  classname: 'remove-option',
  format: null,
  price: null
}
